<section class="min-h-screen py-16 text-center">
  <div class="flex flex-col items-center max-w-4xl gap-4 mx-auto header">
    <h2 class="text-3xl font-bold text-white">خدماتنا</h2>

    <p class="text-white description">الخدمات التي نقدمها لعملائنا</p>

    <img src="/icons/V-icon.svg" alt="icon" class="pb-16 mt-2 w-18" />
  </div>

  <div class="space-y-15">
    <!-- 01 -->
    <div
      class="grid md:grid-cols-2 items-center bg-(-color-secondary) overflow-hidden w-[90%] mx-auto"
    >
      <!-- Text -->
      <div class="px-8 py-10 text-right">
        <span class="block text-(--color-main) text-5xl font-bold"> 01 </span>

        <h3 class="text-(--color-main) text-5xl font-extrabold mt-2">إدارة المشاريع الزراعية</h3>

        <p class="mt-4 text-xl text-white">
          تخطيط وتنفيذ وإدارة المشاريع الزراعية باستخدام أحدث التقنيات لتحقيق أعلى إنتاجية واستدامة.
          نتولى عنك كافة المراحل من اختيار الأرض وتجهيزها، إلى الزراعة والمتابعة، وصولاً إلى الحصاد
          والتسويق.
        </p>
      </div>
      <!-- Image (Left) -->
      <div class="h-full">
        <img
          src="/images/service-1.png"
          class="w-full"
          alt="service-1"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>

    <!-- 02 -->
    <div
      class="grid md:grid-cols-2 items-center bg-(--color-secondary) overflow-hidden w-[90%] mx-auto"
    >
      <!-- Image -->
      <div class="h-full">
        <img
          src="/images/service-2.png"
          class="w-full"
          alt="service-2"
          loading="lazy"
          decoding="async"
        />
      </div>

      <!-- Text -->
      <div class="px-8 py-10 text-right">
        <span class="block text-(--color-main) text-5xl font-bold"> 02 </span>

        <h3 class="text-(--color-main) text-5xl font-extrabold mt-2">الإستشارات الزراعية</h3>

        <p class="mt-4 text-xl text-white">
          تقديم دراسات جدوى وحلول استشارية تساعد المتعاقدين على اتخاذ قرارات زراعية ناجحة. فريقنا من
          المهندسين الزراعيين والخبراء الماليين جاهز لتحليل أي فرصة وتقديم رؤية واضحة للمخاطر
          والعوائد.
        </p>
      </div>
    </div>

    <!-- 03 -->
    <div
      class="grid md:grid-cols-2 items-center bg-(-color-secondary) overflow-hidden w-[90%] mx-auto"
    >
      <!-- Text -->
      <div class="px-8 py-10 text-right">
        <span class="block text-(--color-main) text-5xl font-bold"> 03 </span>

        <h3 class="text-(--color-main) text-5xl font-extrabold mt-2">الزراعة المستدامة</h3>

        <p class="mt-4 text-xl text-white">
          تطبيق أنظمة زراعية مستدامة تحافظ على الموارد الطبيعية وتحقق عوائد طويلة الأمد. نستخدم
          تقنيات الري الحديث، والزراعة العضوية، وإدارة التربة الذكية لضمان مستقبل أفضل للأرض
          ولعوائدك.
        </p>
      </div>

      <!-- Image -->
      <div class="h-full">
        <img
          src="/images/service-3.png"
          class="w-full"
          alt="service-3"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>
  </div>

  <!-- button -->
  <div class="flex justify-center mt-10 cursor-pointer">
    <button
      routerLink="/services"
      class="text-(--color-main) bg-(--color-secondary) px-12 h-12 rounded-3xl font-bold inline-flex items-center gap-2 cursor-pointer border-2 border-(--color-main) hover:bg-(--color-main-20) hover:text(--color-main) transition-all duration-300"
    >
      اعرف المزيد عن خدماتنا
    </button>
  </div>
</section>
